import { useCity } from '../../contexts/CityContext';
import styles from './CurrentCityBadge.module.css';
import { MdLocationCity } from 'react-icons/md';

const CurrentCityBadge = () => {
  const { currentCity, setShowCitySelector } = useCity();

  if (!currentCity) return null;

  return (
    <button 
      className={styles.cityBadge} 
      data-glow
      onClick={() => setShowCitySelector(true)}
      title="Şehri değiştirmek için tıklayın"
    >
      <div className={styles.badgeContent}>
        <MdLocationCity className={styles.icon} />
        <span className={styles.cityName}>{currentCity.cityName}</span>
      </div>
    </button>
  );
};

export default CurrentCityBadge;
